import { requirePermission } from "@/lib/casl/route-guards";
import { MentorDataDashboard } from "@/components/mentor-data-dashboard";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

const searchSchema = z
  .object({
    mentorId: z.preprocess(
      (value) => (value === "" || value === "all" ? undefined : value),
      z.string().uuid().optional(),
    ),
  })
  .passthrough();

export const Route = createFileRoute("/_authenticated/mentor-data-dashboard")({
  component: MentorDashboard,
  validateSearch: searchSchema,
  beforeLoad: ({ context }) => {
    requirePermission(context.user, "read", "analytics");
  },
});

function MentorDashboard() {
  return <MentorDataDashboard />;
}
